import {
  AggregationType,
  Frequency,
  KpiOption,
  KpiVisibilityFlag,
  LastResult,
  Thresholds
} from '@hconnect/common/types'

import {UnitType} from '../../../../common/enums'

export enum ThresholdsName {
  HighHigh = 'highHigh',
  High = 'high',
  Low = 'low',
  LowLow = 'lowLow'
}

export type KpiAggregationTypeOption = {
  id: AggregationType
  label: string
  disabled: boolean
}

export type KpiUnitOption = {
  id: string
  label: string
}
export type KpiWeight = {
  id: string
  label: string
}

export type KpiFormProps = {
  kpiTagname: string
  kpiDisplayName: string
  kpiUnit: string | null
  kpiAggregationType?: AggregationType
  weightKpi?: string
  kpiId: number
  kpiVisibilityFlags: KpiVisibilityFlag[]
}

export type DropDownConfig = {
  value: Frequency
  label: string
}

export type ThresholdsData = {
  thresholds: Partial<Thresholds>
}

export type JanusKpi = {
  id: string
  accountNumber: string
  name: string
  description: string
  shortDescription: string
  active: boolean
  kpiPeriodTypeId: number
  configuration: string
  unitTypeId: number
  order: number
  decimalPrecision: number
  planningOptional: boolean
  kpiPeriodType: number
  unitType: UnitType
}

export type JanusSpecificKpi = {
  id: string
  janusKpiId: string
  unitTypeId: number
  typeId: number
  upmPlantId: string
  active: boolean
  displayName: string
  namePrefix: string
  nameSuffix: string
  order: number
  specificKpiTreeNodeId: string
  janusKpi: JanusKpi
  unitType: UnitType
}

export type SensorsResponse = {
  plantSensors: Sensor[]
}

export type Sensor = {
  sensorName: string
  description: string
}

export type FunctionsResponse = {
  functionDefinitions: FunctionDefinition[]
}

export type LastResultsResponse = {
  results: LastResult[]
}

export enum ArgumentType {
  Val = 'val',
  Fix = 'fix',
  Sensor = 'sensor',
  Enum = 'enum'
}

type Argument = {
  name: string
  description: string
  type: ArgumentType
  data: string
  isMandatory: boolean
  argumentOrder: number
}

export type FunctionDefinition = {
  name: string
  description: string
  arguments: Argument[]
  maxArguments: number
}

export type UnitsResponse = string[]
export type KpiNamesResponse = string[]

export type Variable = {
  name: string
  description: string
}

export type FrequencyDropDownConfig = {
  value: Frequency
  label: string
}

export enum KpiFormField {
  KpiDefinitionId = 'kpiDefinitionId',
  KpiName = 'kpiName',
  KpiType = 'kpiType',
  KpiMainEquipment = 'kpiMainEquipment',
  Unit = 'unit',
  AggregationType = 'aggregationType',
  WeightKpi = 'weightKpi',
  KpiVisibilityFlags = 'kpiVisibilityFlags'
}

export type NewKpi = {
  kpiMainEquipment: KpiOption | null
  kpiType: KpiOption | null
  unit: KpiUnitOption | null
  aggregationType: KpiAggregationTypeOption | null
  weightKpi: KpiWeight | null
  customFormula: string
}

export type KpiPayload = {
  departmentUpmId: string
  formula: string
  kpiTagName: string
  kpiType: string
  unit: string
  aggregationType: AggregationType
  weightKpiAssignmentId?: string
}
